
import { CookieSetInput, CookieSetRequest } from "./CookieSetRequest";
import { CookieGetInput, CookieGetRequest, CookieGetResponse } from "./CookieGetRequest";
import { PHPContext } from "../PHPContext";
import { PHPResponse } from "../PHPResponse";

export class Cookies
{
  static async set( phpContext:PHPContext, name:string, value:string ):Promise<PHPResponse>
  {
    let input = new CookieSetInput();
    let request = new CookieSetRequest();

    input.name = name;
    input.value = value;

    let response = await request.request( phpContext, input );

    return response;
  }   

  static async get( phpContext:PHPContext, name:string ):Promise<CookieGetResponse>
  {
    let input = new CookieGetInput();
    input.name = name;
    
    let request = new CookieGetRequest();
    let cookieResponse = await request.request( phpContext, input );

    return cookieResponse;
  }
}